import React, { useEffect, useState } from 'react';
import { Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, Layout } from 'antd';

import LfContent from './LfContent';
import ByContent from './ByContent';

const { Header, Sider } = Layout;

const items = [
  { key: 'lfContent', label: <Link to="/lfContent">LF内容</Link> },
  { key: 'byContent', label: <Link to="/byContent">BY内容</Link> },
];

const MainPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState('lfContent');

  useEffect(() => {
    const currentLocation = window.location.pathname;
    
    if (currentLocation === '/') {
      navigate('/lfContent');
    } else {
      // 根据路由设置选中的菜单项
      const path = currentLocation.substring(1); // 去掉开头的 /
      setSelectedKey(path);
    }
  }, [navigate, location]);

  const onClick = (e) => {
    console.log('click ', e);
    setSelectedKey(e.key);
  };

  return (
    <Layout>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >   
        <div className="demo-logo" />
      </Header>
      
      <Layout>
        <Sider width={200} theme="light">
          <Menu
            theme="light"
            onClick={onClick}
            style={{ width: 200 }}
            selectedKeys={[selectedKey]} 
            mode="inline"
            items={items}
          />
        </Sider>
        
        <Layout style={{ padding: '0 24px 24px' }}>
          <div style={{ flex: 1, padding: '20px', overflowX: 'auto' }}>
            <Routes>
              <Route path="/lfContent" element={<LfContent />} />
              <Route path="/byContent" element={<ByContent />} />
            </Routes>
          </div>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainPage;
